@import '../../utils/forced-colors.css';
@import '../../utils/visually-hidden.css';

:host {
  display: block;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  -webkit-user-select: none;
  user-select: none;
}

.questionnaire {
  display: grid;
  gap: var(--dimension-space-150);
  width: 100%;
  padding: var(--dimension-space-200);
  border-radius: var(--dimension-radius-125);
  background: var(--color-background-primary);
  box-shadow: var(--effect-elevation-elevated-md);
  box-sizing: border-box;
}

.questionnaire--answered {
  gap: var(--dimension-space-100);
  padding: var(--dimension-space-150);
  background: var(--color-background-secondary);
  box-shadow: none;
}

.questionnaire--preparing {
  align-items: center;
  grid-template-columns: auto minmax(0, 1fr);
}

.questionnaire__header,
.questionnaire__actions,
.questionnaire__actions-leading,
.questionnaire__error,
.questionnaire__submission-error {
  display: flex;
  align-items: center;
}

.questionnaire__header,
.questionnaire__actions {
  justify-content: space-between;
  gap: var(--dimension-space-100);
}

.questionnaire__body,
.questionnaire__prompt,
.questionnaire__choices,
.questionnaire__single-choice,
.questionnaire__multiple-choice,
.questionnaire__other-choice,
.questionnaire__summary,
.questionnaire__summary li {
  display: grid;
}

.questionnaire__body,
.questionnaire__prompt,
.questionnaire__choices,
.questionnaire__single-choice,
.questionnaire__multiple-choice,
.questionnaire__other-choice {
  gap: var(--dimension-space-100);
}

.questionnaire__choices {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

ds-radio,
ds-checkbox {
  width: 100%;
  min-width: 0;
}

.questionnaire__other-input,
.questionnaire__text-input {
  width: 100%;
  padding: var(--dimension-space-100);
  border: var(--dimension-stroke-width-012) solid var(--color-border-secondary);
  border-radius: var(--dimension-radius-050);
  outline: none;
  background: var(--color-background-primary);
  color: var(--color-foreground-primary);
  font-family: var(--typography-font-family-ui);
  font-size: var(--typography-fontsize-md);
  font-weight: var(--typography-weight-regular);
  line-height: var(--typography-lineheight-md);
  letter-spacing: var(--typography-letterspacing-negative-half);
  box-sizing: border-box;
  -webkit-user-select: text;
  user-select: text;
}

.questionnaire__other-input {
  width: calc(100% - var(--dimension-size-500));
  margin-inline-start: var(--dimension-size-500);
}

.questionnaire__text-input {
  min-height: calc(var(--typography-lineheight-md) * 4 + var(--dimension-space-200));
  resize: vertical;
}

.questionnaire__other-input:focus,
.questionnaire__text-input:focus {
  border-color: var(--color-border-bold-brand);
  box-shadow: inset 0 0 0 var(--dimension-stroke-width-018)
    var(--color-border-bold-brand);
}

.questionnaire__other-input[aria-invalid='true'],
.questionnaire__text-input[aria-invalid='true'] {
  border-color: var(--color-border-bold-negative);
}

.questionnaire__error,
.questionnaire__submission-error {
  gap: var(--dimension-space-050);
  color: var(--color-foreground-bold-negative);
}

.questionnaire__submission-error {
  padding: var(--dimension-space-075);
  border-radius: var(--dimension-radius-050);
  background: var(--color-background-faint-negative);
}

.questionnaire__actions-leading {
  flex-wrap: wrap;
  gap: var(--dimension-space-075);
}

.questionnaire__action-item {
  width: fit-content;
  max-width: 100%;
}

.questionnaire textarea:disabled {
  color: var(--color-foreground-tertiary);
  cursor: default;
  opacity: 1;
}

.questionnaire__summary {
  gap: var(--dimension-space-100);
  margin: 0;
  padding: 0;
  list-style: none;
}

.questionnaire__summary li {
  gap: var(--dimension-space-025);
}

@media (max-width: 480px) {
  .questionnaire {
    padding: var(--dimension-space-150);
  }

  .questionnaire__actions {
    align-items: stretch;
    flex-direction: column;
  }

  .questionnaire__actions-leading {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    width: 100%;
  }

  .questionnaire__action-item,
  .questionnaire__action-item--primary {
    width: 100%;
  }
}

@media (forced-colors: active) {
  .questionnaire {
    border: var(--dimension-stroke-width-012) solid var(--ds-forced-color-content);
    box-shadow: none;
  }

  .questionnaire__other-input[aria-invalid='true'],
  .questionnaire__text-input[aria-invalid='true'] {
    outline: var(--dimension-stroke-width-025) dashed var(--ds-forced-color-content);
  }

  .questionnaire__submission-error {
    border: var(--dimension-stroke-width-012) solid var(--ds-forced-color-content);
    background: var(--ds-forced-color-surface);
  }

  .questionnaire input:disabled,
  .questionnaire textarea:disabled {
    color: var(--ds-forced-color-disabled);
  }
}
